import { Component } from '@angular/core';
import { filterPageTypes } from 'src/app/store/filters.era';
import { PAGE_NAME } from 'globals/store/permissions.data';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { TaskCalendarPageComponent } from './task-calendar.page';

@Component({
    selector: 'my-task-calendar-page',
    template: `<app-task-calendar-page [isMyTasks]="true" [page_name]="page_name" [traceName]="traceName" [filterPage]="filterPage"></app-task-calendar-page>`,
    styleUrls: ['../../page.pass-through.scss'],
    standalone: true,
    imports: [TaskCalendarPageComponent]
})
export class MyTaskCalendarPageComponent {
    page_name = PAGE_NAME.my_tasks_calendar;
    traceName = traceNames.viewMyTasksCalendar;
    filterPage = filterPageTypes.myTasks;
}

